document.addEventListener("DOMContentLoaded", function () {
  const productGrids = document.querySelectorAll(".grid.product-grid");

  productGrids.forEach(function (productGrid) {
    const sectionId = productGrid.getAttribute("data-section-id");
    if (!sectionId) return;

    const variantDataMap = window["variantDataMap" + sectionId.replace(/-/g, "_")];
    if (!variantDataMap) return;

    // Use 'click' event for labels, which is more reliable for custom styled inputs
    productGrid.addEventListener("click", function (e) {
      // Find the actual radio input if a label was clicked
      const swatchInput = e.target.control || (e.target.closest('.collection-product-card__swatch') ? e.target.closest('.collection-product-card__swatch').querySelector('input') : null);

      if (swatchInput) {
        const card = swatchInput.closest('.card-wrapper');
        if (!card) return;

        // DEFINITIVE FIX: Read the variant ID from the 'data-variant-id' attribute.
        const variantId = swatchInput.dataset.variantId;
        const variantData = variantDataMap[variantId];

        if (!variantData) {
          // This can happen if a variant is sold out and has no ID, which is fine.
          return;
        }

        const productImageElement = card.querySelector(".card__media img");
        if (productImageElement) {
            const dynamicSrcset = [
              `${variantData.imageUrl}&width=165 165w`,
              `${variantData.imageUrl}&width=360 360w`,
              `${variantData.imageUrl}&width=533 533w`,
              `${variantData.imageUrl}&width=720 720w`
            ].join(", ");
            
            productImageElement.src = variantData.imageUrl;
            productImageElement.srcset = dynamicSrcset;
        }

        const productLinks = card.querySelectorAll('a.full-unstyled-link');
        productLinks.forEach(function (link) {
          link.href = variantData.productUrl;
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const swatchInputs = document.querySelectorAll('.collection-product-card__swatch input[type="radio"]');

  swatchInputs.forEach(input => {
    input.addEventListener('change', function() {
      const productCard = this.closest('.product-card-wrapper');
      if (productCard) {
        const mainImage = productCard.querySelector('.card__media img');
        const newImageUrl = this.dataset.imageUrl;

        if (mainImage && newImageUrl) {
          mainImage.src = newImageUrl;
          mainImage.srcset = newImageUrl;
        }
      }
    });
  });
});
/**
 * Handles variant swatch selection on collection pages.
 * Uses event delegation for performance and reliability.
 */
document.addEventListener('change', function(event) {
  // 1. Check if the element that triggered the event is a variant swatch input.
  if (!event.target.matches('.variant-swatch-input')) {
    return;
  }

  const swatchInput = event.target;

  // 2. Find the parent product card container for the clicked swatch.
  // The .closest() method traverses up the DOM tree to find the nearest matching ancestor.
  const productCard = swatchInput.closest('.product-card-wrapper');

  if (!productCard) {
    console.error('Swatch Error: Could not find a parent ".product-card-wrapper" for the clicked swatch.');
    return;
  }

  // 3. Find the main product image *within that specific card*.
  // We use the specific class 'product-card__image' that we added in step 1.
  const mainImage = productCard.querySelector('.product-card__image');

  if (!mainImage) {
    console.error('Swatch Error: Could not find an element with class ".product-card__image" inside the card.');
    return;
  }

  // 4. Get the new image URL from the selected swatch's data attribute.
  const newImageUrl = swatchInput.dataset.imageUrl;

  // 5. Update the main image's src and srcset attributes, if the URL is valid.
  if (newImageUrl) {
    mainImage.src = newImageUrl;
    mainImage.srcset = newImageUrl; // Update srcset to prevent showing a stale image.
  }
});